import Actions                  from 'Redux/Actions';
import { EventRepository }      from 'Domain/Repositories';
import { ofType }               from 'redux-observable';
import { from }                 from 'rxjs';
import { mergeMap, catchError } from 'rxjs/operators';
import { TEpic }                from 'Redux/Config';
import { message }              from 'antd';

export const downloadEventReportEpic: TEpic = (action$) => {
  return action$.pipe(
    ofType(Actions.downloadEventReportRequest.type),
    mergeMap(action => from(EventRepository.downloadEventReport(action.payload.id))
      .pipe(
        mergeMap(() => {
          return from([
            Actions.downloadEventReportSuccess(),
          ]);
        }),
        catchError(error => {
          return from([
            Actions.downloadEventReportFailure({ error })
          ]);
        })
      )
    ),
  );
};
